import { render, staticRenderFns } from "./StateHeader.vue?vue&type=template&id=835656f4&scoped=true&"
import script from "./StateHeader.vue?vue&type=script&lang=js&"
export * from "./StateHeader.vue?vue&type=script&lang=js&"
import style0 from "./StateHeader.vue?vue&type=style&index=0&id=835656f4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "835656f4",
  null
  
)

export default component.exports